import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { IGoogleMaterialIconProps } from './google-material-icon.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'google-material-icon',
  props: {
    props: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([
            'material-icon',
            __props.props.selected ? 'material-icons' : 'material-icons-outlined',
        ]),
    style: _normalizeStyle({ color: __props.props.color })
  }, _toDisplayString(__props.props.iconName), 7))
}
}

})